export class TransportParser {
    constructor(id, name) {
        this.id = id;
        this.name = name;
        this.legacy = false;
    }
    makeLegacy() {
        this.legacy = true;
        return this;
    }
}
